import React from "react";
import "../components/cta.css";

const Cta = () => {
  return (
    <div className="gpt3__cta_1">
      <div className="gpt3__cta-content_1">
        <h3>We empower businesses to thrive in the digital age through customized IT services & cloud solutions</h3>
      </div>
      
    </div>
  );
};

export default Cta;
